module.exports = __webpack_public_path__ + "static/img/5.64211c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/5.jpg
// module id = z0ah
// module chunks = 1